<template>
  <div>
    <v-head :title="title"></v-head>
    <div class="signup" style="width: 100%; position: absolute;height: 100%;background: #f3f3f3;" v-wechat-title="$route.meta.title">
      <div class="inputBox">
        <div class="inputCont" style="padding-top:35px">
          <div class="inputkuang">
            <dl>
              <dt>会员姓名<sup>*</sup></dt>
              <dd>
                <van-field v-model="params.name" placeholder="请输入会员姓名" />
              </dd>
            </dl>
            
            <div class="buttonDiv">
              <van-button type="primary" block class="but1" @click="search()">提交查询</van-button>
              <van-button type="primary" block @click="goSearch">返回报名</van-button>
            </div>

             <!-- 竖排表格展示 -->
            <div v-if="gridData.length > 0" class="vertical-table">
              <div v-for="(item, index) in gridData" :key="index" class="member-card">
                <van-cell-group>
                  <van-cell title="姓名" :value="item.name" />
                  <van-cell title="会员编号" :value="item.memberNo" />
                  <van-cell title="有效期" :value="formatDate(item.expiryDate)" />
                  <van-cell title="所在单位" :value="item.company" />
                </van-cell-group>
              </div>
            </div>
            <div v-if="isMember" class="member-item">
              <div style="text-align: center; padding-top: 80px; color: #686868; font-size: 22px;">暂无会员数据</div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getRegisterMeetingDetail, getPZUrl, getMeetingDetail, getUser } from "@/api/dictionary";
  import { Icon, Row, Col, Button, Swipe, SwipeItem, Dialog, Divider, Field, Toast, Cell, CellGroup } from "vant"; // 添加 Cell 和 CellGroup
  import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
  import { getMobileLoginCode, checkRegisterCode, getMembers } from "@/api/login";
  import vHead from "@/components/Subhead.vue";

  export default {
    data() {
      return {
        type: "1",
        show: null,
        code: null,
        tipContent: "",
        url: "",
        meetingDetail: {},
        title: '会员查询',
        params: {
          name: null,
          mobile: null,
          meetingId: null
        },
        gridData: [],
        isMember: false,
      };
    },
    components: {
      vHead,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [Button.name]: Button,
      [SwipeItem.name]: SwipeItem,
      [Swipe.name]: Swipe,
      [Dialog.name]: Dialog,
      [Divider.name]: Divider,
      [Field.name]: Field,
      [Toast.name]: Toast,
      [Cell.name]: Cell,          // 添加 Cell 组件
      [CellGroup.name]: CellGroup // 添加 CellGroup 组件
    },
    computed: {
      meetingId() {
        return this.$route.query && this.$route.query.meetingId;
      },
    },
    methods: {
      goSearch() {
        this.$router.push({ name: 'signup', query: { meetingId: this.meetingId } });
      },

      search() {
        if (!this.params.name) {
          Toast("会员姓名不能为空");
          return;
        }
        let params = { ...this.params }
        params.certificate = 1
        getMembers(params, 0).then(res => {
            if (res.success) {
                this.gridData = res.result.content;
                if (this.gridData.length <= 0) {
                  this.isMember = true
                }else {
                  this.isMember = false
                }
            }
        })
      },

      formatDate(date) {
        if (!date) return '';
        return date.substring(0, 10); // 返回 YYYY-MM-DD 格式
      }
    },
    mounted() {
      if (!this.params.meetingId) {
        this.params.meetingId = this.meetingId;
      }
    }
  };
</script>

<style scoped lang="less">
  .button-3 {
    background-color: #1989fa;
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 10px 20px 10px 20px;
  }

  .text-70 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 17px;
  }

  .button-6 {
    background-color: rgba(250, 173, 122, 0.14);
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 10px 20px 10px 20px;
  }

  .text-71 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  /deep/.van-field__value {
    width: 100%;
  }
  
  .vertical-table {
    margin: 20px 0;
  }
  
  .member-card {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .card-actions {
    padding: 15px;
    text-align: center;
    background: #f9f9f9;
  }
</style>